import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CopyFill = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9H15V5.67V5.67002C14.9945 4.1977 13.8023 3.0055 12.33 3H5.67V3C4.19768 3.00548 3.00548 4.19768 3 5.67V12.33L3 12.33C3.00547 13.8023 4.19766 14.9945 5.66998 15H9V18C9 19.6569 10.3432 21 12 21H18C19.6569 21 21 19.6569 21 18V12C21 10.3432 19.6569 9 18 9V9ZM9 12V13H5.67C5.29997 13 5 12.7 5 12.33V5.67C5 5.29997 5.29997 5 5.67 5H12.33C12.7 5 13 5.29997 13 5.67V9H12C10.3432 9 9 10.3432 9 12H9Z",
    fill: "currentColor"
  })
});